import { plural } from '@cian/utils';
import * as React from 'react';

import { Container } from '../../components/Container';
import { Link } from '../../components/Link';
import { Text } from '../../components/Text';
import { SIZE_8, SIZE_12, SIZE_16 } from '../../constants/sizes';
import { IBuildingStatus } from '../../types/newbuilding/newbuilding';
import { memoizeWith } from 'ramda';

interface IBuildingStatusesProps {
  statuses: IBuildingStatus[] | null;
  setPage(url: string): void;
}

const getStatusDescription = (status: IBuildingStatus) => {
  const { statusId, housesCount, count } = status;
  const houses = plural(housesCount, ['дом', 'дома', 'домов']);

  switch (statusId) {
    case 5004: {
      return `${plural(housesCount, ['Сдан', 'Сдано', 'Сдано'])} ${housesCount} ${houses} в ${count} ЖК`;
    }

    case 5002: {
      return `${plural(housesCount, ['Строится', 'Строятся', 'Строятся'])} ${housesCount} ${houses} в ${count} ЖК`;
    }

    default: {
      return '';
    }
  }
};

const getStatusDescriptionMemo = memoizeWith(JSON.stringify, getStatusDescription);

export const BuilderBuildingStatuses: React.StatelessComponent<IBuildingStatusesProps> = (props) => {
  const { statuses, setPage } = props;

  if (statuses === null) {
    return null;
  }

  return (
    <Container
      margin={`${SIZE_12} 0 ${SIZE_16} 0`}
      display="flex"
    >
      {statuses.map((status, index, array) => (
        <React.Fragment
          key={index}
        >
          <Container
            margin={`0 0 ${SIZE_8} 0`}
            display="flex"
          >
            <Link
              url={status.url}
              onClick={() => setPage(status.url)}
              notChangeLocation
            >
              <Text
                fontSize={14}
                lineHeight={20}
                color="blue"
                colorHovered="red"
              >
                {getStatusDescriptionMemo(status)}
              </Text>
            </Link>
          </Container>
          {
            array.length - 1 !== index &&
            <span style={{ margin: '0 7px' }}>{'  ·  '}</span>
          }
        </React.Fragment>
      ))}
    </Container>
  );
};
